<template>
  <nav aria-label="Breadcrumb">
    <ol class="breadcrumbs">
      <li v-for="(crumb, index) in items" :key="index" class="breadcrumb-item">
        <template v-if="!crumb.url || index === items.length - 1">
          <span :class="{ current: index === items.length - 1 }">
            <font-awesome-icon v-if="crumb.icon" :icon="crumb.icon" />
            <span v-if="crumb.label"> {{ crumb.label }}</span>
          </span>
        </template>
        <template v-else-if="crumb.url">
          <router-link :to="crumb.url">
            <font-awesome-icon v-if="crumb.icon" :icon="crumb.icon" />
            <span v-if="crumb.label"> {{ crumb.label }}</span>
          </router-link>
        </template>
        <span v-if="index < items.length - 1" class="separator">
          /
        </span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    items: {
      type: Array,
      required: true,
      validator: arr =>
        arr.every(
          item =>
            typeof item === 'object' &&
            (typeof item.url === 'string' || typeof item.url === 'object' || item.url === undefined) &&
            (typeof item.label === 'string' || item.label === undefined) &&
            (typeof item.icon === 'object' || item.icon === undefined)
        )
    }
  }
}
</script>

<style scoped>
.breadcrumbs {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}
.breadcrumb-item {
  display: flex;
  align-items: center;
  a {
    text-decoration: none;
    color: var(--deep-sapphire);
    transition: color 0.2s ease;
    &:hover {
      color: #000;
    }
  }
}
.separator {
  margin: 0 8px;
  color: #aaa;
}
.current {
  font-weight: bold;
  color: #333;
}
</style>
